import React from "react";
import Select from "react-select";
import { verifyPermission } from "helpers/permission";

const InstitutionSelector = ({
  userPermissions,
  institutionData,
  institution,
  onChangeInstitution,
  error,
  t,
}) => {
  const hasPermission = verifyPermission(
    userPermissions,
    "update-processing-circuit-any-institution"
  );

  if (!hasPermission) return null;

  return (
    <div
      className={
        error.institution_id.length
          ? "form-group row validated"
          : "form-group row"
      }
    >
      <label
        className="pl-3 col-form-label"
        htmlFor="institutionSelect"
      >
        {t("Sélectionnez une institution")}
      </label>
      <div className="col-lg-9 col-xl-6">
        {institutionData ? (
          <Select
            id="institutionSelect"
            placeholder={t("Veuillez sélectionner l'institution")}
            value={institution}
            onChange={onChangeInstitution}
            options={institutionData.length ? institutionData[0] : []}
          />
        ) : (
          <select
            name="category"
            className={
              error.institution_id.length
                ? "form-control is-invalid"
                : "form-control"
            }
            id="category"
          >
            <option value="" />
          </select>
        )}
      </div>
      {error.institution_id.length > 0 &&
        error.institution_id.map((errorMsg, index) => (
          <div key={index} className="invalid-feedback">
            {errorMsg}
          </div>
        ))}
    </div>
  );
};

export default InstitutionSelector;
